export default {"src":"/_next/static/media/twitter-bold-white.414761af.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};